<template>
  <div class="searchDutyAreaPage">
    <div class="searchTit clearfix">
      <a href="javascript:void(0);" class="fl" @click="goBack">
        <van-icon name="arrow-left" />
      </a>
      <p>{{ $t("searchMsg.searchDutyAreaTit") }}</p>
    </div>
    <!-- <div class="searchBox">
      <van-cell-group>
        <van-field
          v-model="searchArea"
          :label="$t('common.politicalTit') + '：'"
          :placeholder="$t('searchMsg.searchTit')"
          readonly
          center
          @click="areaShowPicker = true"
          class="searchType"
        ></van-field>
        <van-button type="primary" size="small" @click="reloadResultList">{{
          $t("common.search")
        }}</van-button>
      </van-cell-group>
    </div> -->
    <div :class="['searchMain', this.showNonePage == true ? 'hideText' : '']">
      <!-- <van-list
        v-model="loading"
        :finished="finished"
        @load="onLoad"
        :offset="100"
        :finished-text="$t('common.noneMore')"
        class="resultList"
      > -->
      <div class="resultList" v-if="baseInfo">
        <ul>
          <zrqarea-Item
            :zrqData="baseInfo"
            :objValue="searchValue"
            @getMapOptions="setMapOptions"
            :isParentOpen="true"
          ></zrqarea-Item>
        </ul>
      </div>
      <!-- </van-list> -->
      <div class="nonePage" v-else>
        <img :src="nonePng" alt />
        <p>{{ $t("common.noDataTip") }}</p>
      </div>
    </div>
    <!-- 省、市、县/区、乡/镇、村两级联动 -->
    <!-- <van-popup v-model="areaShowPicker" position="bottom">
      <div class="searchPage">
          
      </div>
      <van-picker
        show-toolbar
        :columns="citys"
        value-key="zqName"
        :cancel-button-text="$t('searchMsg.clearText')"
        @cancel="onClearArea"
        @confirm="onSaveArea"
      />
    </van-popup> -->
    <!-- 责任区详情 弹框 -->
    <div class="zrqStyle" v-if="showDutyAreaType">
      <div class="zgc">
        <a href="javascript:void(0);" @click="closePage">
          <i class="van-icon van-icon-arrow-left"></i>
        </a>
        <p>详情</p>
      </div>
      <!-- 责任区详情 -->
      <dutyArea
        :param="{
          id: this.dataInfo.objid,
          type: this.dataInfo.areaType,
          zqCode: this.dataInfo.zqCode,
          level: this.dataInfo.level,
          showMap: false,
        }"
      />
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import zrqareaItem from "./child/responsibility-zrqareaItem";
import dutyArea from "../universal/dutyArea";
import { getaeraList } from "@/utils/common";
import nonePng from "@/assets/none.png";
import { mapState } from "vuex";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "searchDutyArea",
  components: {
    dutyArea,
    zrqareaItem,
  },
  data() {
    return {
      editType: true,
      nonePng: nonePng, //默认图片
      showNonePage: false, //
      searchArea: "",
      searchValue: {
        zqCode: "", //城市区域码
        gridType: "",
        objid: "",
      }, //搜索值
      childZqCode: "",
      resultData: [],
      areaShowPicker: false, //
      backstagelists: [],
      baseInfo: {},
      // page: 0,
      // pageSize: 10,
      // commentCount: 0,
      // loading: false, //是否处于加载状态
      // finished: false, //是否已加载完所有数据
      // isLoading: false, //是否处于下拉刷新状态
      // citys: [],
      showDutyAreaType: false, //是否显示责任区详情
      dataInfo: "", //向子组件传值
      clientType: "", //手机类型
    };
  },
  mounted() {
    // this.citys = await getaeraList(this.userinfo.zqCode);
    this.clientType = getDeviceType();
    this.$nextTick(() => {
      if (this.searchObj && this.userinfo) {
        this.initPage();
      }
    });
  },

  methods: {
    initPage() {
      if (
        this.userinfo &&
        this.searchObj &&
        this.searchObj.objid &&
        this.userinfo.zqCode
      ) {
        // this.citys = await getaeraList(
        //   this.searchObj.zqCode ? this.searchObj.zqCode : this.userinfo.zqCode
        // );
        this.$set(this.searchValue, "gridType", this.searchObj.zrqlx);
        this.$set(this.searchValue, "objid", this.searchObj.objid);
        this.$set(
          this.searchValue,
          "zqCode",
          this.searchObj.zqCode ? this.searchObj.zqCode : this.userinfo.zqCode
        );
        if (this.searchValue.zqCode) {
          this.getTest();
        }
      }
    },
    getTest() {
      let _this = this;
      // if (_this.page != 0 && this.page * 10 >= parseInt(_this.commentCount)) {
      //   return;
      // }
      // _this.page += 1;
      // console.log(_this.searchValue);
      // _this.$api.search
      //   .resourceGridList(_this.page, _this.pageSize, _this.searchValue)
      //   .then((res) => {
      //     if (res.code == "1") {
      //       if (res.data.list != null) {
      //         // let total = parseInt(res.data.total);
      //         // _this.commentCount = total;
      //         _this.backstagelists = res.data.list;

      //         // _this.viewLists();
      //         // // 加载状态结束
      //         // _this.loading = false;
      //         // if (_this.page * 10 >= total) {
      //         //   _this.finished = true;
      //         //   _this.editType = true;
      //         //   console.log("加载完成");
      //         // }
      //       } else {
      //         // _this.finished = true;
      //         // _this.editType = true;
      //         this.showNonePage = true;
      //       }
      //     } else {
      //       _this.$toast(res.msg);
      //     }
      //   })
      //   .catch((err) => {
      //     this.refreshPage = true;
      //     console.log(err);
      //   });

      _this.$api.search.resourceZqAndZrqTree(_this.searchValue).then((res) => {
        if (res.code == "1" && res.data != null) {
          console.log(res.data, "res.data");
          _this.baseInfo = res.data;
          // if (res.data.list != null) {
          // let total = parseInt(res.data.total);
          // _this.commentCount = total;
          // _this.backstagelists = res.data.list;

          // _this.viewLists();
          // // 加载状态结束
          // _this.loading = false;
          // if (_this.page * 10 >= total) {
          //   _this.finished = true;
          //   _this.editType = true;
          //   console.log("加载完成");
          // }
          // } else {
          // _this.finished = true;
          // _this.editType = true;

          // }

          console.log(_this.baseInfo, " _this.baseInfo");
        } else {
          _this.$toast(res.msg);
          this.showNonePage = true;
        }
      });
    },
    // viewLists() {
    //   this.resultData = this.resultData.concat(this.backstagelists);
    //   if (this.resultData.length < 1) {
    //     this.showNonePage = true;
    //   } else {
    //     this.showNonePage = false;
    //   }
    // },
    // onLoad() {
    //   // 异步更新数据
    //   setTimeout(() => {
    //     if (this.searchValue.zqCode) {
    //       this.getTest();
    //     }
    //   }, 500);
    // },
    // reloadResultList() {
    //   let _this = this;
    //   if (_this.editType) {
    //     _this.editType = false;
    //     _this.showNonePage = false;
    //     _this.loading = true; //是否处于加载状态
    //     _this.finished = false;

    //     _this.searchValue.zqCode == ""
    //       ? (_this.searchValue.zqCode = _this.searchObj.zqCode
    //           ? _this.searchObj.zqCode
    //           : _this.userinfo.zqCode)
    //       : (_this.searchValue.zqCode = _this.searchValue.zqCode);

    //     (_this.page = 0), (_this.pageSize = 10), (_this.commentCount = 0);
    //     _this.resultData = [];
    //     _this.getTest();
    //   } else {
    //     _this.$toast(_this.$t("common.moreClickToastMsg"));
    //   }
    // },
    // onSaveArea(value, index) {
    //   //保存的政区
    //   this.searchArea = value[0] + value[1];
    //   this.searchValue.zqCode = this.citys[index[0]].children[index[1]].zqCode;
    //   this.areaShowPicker = false;
    // },
    // onClearArea(value, index) {
    //   //清空政区内容
    //   this.searchArea = "";
    //   this.searchValue.zqCode = "";
    //   this.areaShowPicker = false;
    // },

    goBack() {
      let _this = this;
      _this.$emit("changeType", true);
      // this.$store.commit("SetcloseShowType", "true");

      this.$store.commit("SetcloseShowType", "open");
    },
    closePage() {
      this.showDutyAreaType = false; //显示林地
      // this.$store.commit("SetcloseShowType", "true");
      this.$store.commit("SetcloseShowType", "open");
    },
    setMapOptions(data) {
      // 接口信息未提供objid
      
      this.dataInfo = {
        objid: data.objid,
        type:
          data.type == "zrq"
            ? this.getGird(data.level)
            : this.getZqLevel(data.level),
        //以下是新改责任区政区合一添加参数
        areaType: data.type,
        level: data.level,
        zqCode: data.zqCode,
      };
      this.childZqCode = data.zqCode;
      this.$store.commit("SetcloseShowType", "close");
      this.showDutyAreaType = true; //显示政区
      this.$emit("getMapOptions", this.dataInfo);
    },
    getGird(num) {
      let type = "";
      if (num == "1") {
        type = "geo_grid_sheng";
      } else if (num == "2") {
        type = "geo_grid_shi";
      } else if (num == "3") {
        type = "geo_grid_xian";
      } else if (num == "4") {
        type = "geo_grid_xiang";
      } else if (num == "5") {
        type = "geo_grid_cun";
      }
      return type;
    },
    getZqLevel(num) {
      let type = "";
      if (num == "1") {
        type = "geo_sheng";
      } else if (num == "2") {
        type = "geo_shi";
      } else if (num == "3") {
        type = "geo_xian";
      } else if (num == "4") {
        type = "geo_xiang";
      } else if (num == "5") {
        type = "geo_cun";
      }
      return type;
    },
  },
  computed: {
    ...mapState(["userinfo", "searchObj"]),
  },
  watch: {
    userinfo: {
      handler: function () {
        // let _this = this;
        // console.log(_this.userinfo);
        // this.searchValue.zqCode = _this.userinfo.zqCode;
        // _this.getTest();
        if (this.userinfo && this.searchObj) {
          _this.initPage();
        }
      },
      deep: true,
    },
    searchObj: {
      handler: function () {
        // let _this = this;
        // this.searchValue.gridType = this.searchObj.zrqlx;
        // this.searchValue.objid = this.searchObj.objid;
        if (this.userinfo && this.searchObj) {
          _this.initPage();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.searchDutyAreaPage {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;

  .searchTit {
    width: 100%;
    padding: 0 16px;
    height: 35px;
    background-color: #fff;
    position: relative;

    a {
      display: inline-block;
      width: 55px;
      padding-left: 15px;
      line-height: 35px;
      font-size: 14px;
      color: #4bc08a;
      position: relative;

      .van-icon {
        position: absolute;
        left: 0;
        top: 11px;
        display: inline-block;
        font-size: 14px;
        color: #4bc08a;
        font-weight: 600;
      }
    }

    p {
      width: 200px;
      line-height: 35px;
      margin: 0 auto;
      color: #666;
      text-align: center;
      font-size: 14px;
    }
  }

  .searchBox {
    width: 100%;
    position: relative;

    .van-cell {
      width: 100%;
      height: 46px;
      padding: 8px 16px;
      box-sizing: border-box;

      .van-field__label {
        color: #666;
        font-size: 12px;

        span {
          line-height: 30px;
        }
      }

      .van-cell__value {
        .van-field__control {
          color: #333;
          font-size: 12px;
          line-height: 30px;
        }
      }
    }

    .searchType.van-cell {
      width: 80%;
    }

    .van-button {
      position: absolute;
      right: 16px;
      bottom: 9px;
    }
  }

  .searchMain {
    width: 100%;
    height: calc(100% - 40px );
    overflow-y: scroll;
    background-color: #f6f6f6;
    position: relative;
    .resultList {
      width: 100%;
      padding: 0 8px;

      .item {
        width: 100%;
        background-color: #fff;
        margin: 10px 0;
        padding: 8px 8px;
        border-radius: 8px;
        -webkit-border-radius: 8px;
        -moz-borer-radius: 8px;
        position: relative;
        p {
          color: #636464;
          font-size: 16px;
          line-height: 20px;
          margin: 10px 0;
          font-weight: 600;
        }

        // p:first-child {
        //   font-size: 14px;
        //   font-weight: 600;

        //   // span {
        //   //   font-weight: 400;
        //   //   text-align: right;
        //   //   font-size: 12px;
        //   //   padding-right: 10px;
        //   // }
        // }
        .isNextLevel {
          display: inline-block;
          padding: 3px 10px;
          background-color: rgba(240, 239, 239, 0.6);
          color: #636464;
          position: absolute;
          top: 5px;
          right: 10px;
          font-size: 12px;
        }
        // p:last-child {
        //   margin-bottom: 0;
        // }
      }
    }

    .nonePage {
      width: 120px;
      height: 150px;

      position: absolute;
      left: 50%;
      margin-left: -60px;
      top: 50%;
      margin-top: -75px;

      img {
        display: block;
        max-width: 100px;
        max-height: 100px;
        margin: 0 auto;
      }

      p {
        margin-top: 10px;
        text-align: center;
        color: #5c5d5d;
        font-size: 16px;
      }
    }
  }
  .searchMain.hideText {
    .van-list__finished-text {
      display: none;
    }
  }
  .zrqStyle {
    position: absolute;
    width: 100%;
    height: calc(100% - 40px);
    top: 40px;
    left: 0;
    padding-top: 40px;
    z-index: 9999 !important;
    background-color: #fff;
    .zgc {
      position: absolute;
      width: 100%;
      height: 40px;
      line-height: 40px;
      background-color: #fff;
      z-index: 9999 !important;
      top: 0;
      left: 0;
      font-size: 15px;
      text-align: center;
      color: #646566;
      a {
        display: inline-block;
        width: 45px;
        color: #4bc08a;
        position: absolute;
        left: 16px;
        top: 0px;
        text-align: left;
        .van-icon {
          line-height: 40px;
          display: inline-block;
          font-size: 14px;
          color: #4bc08a;
          font-weight: 600;
        }
      }
    }
  }
}
</style>